import { createActionGroup, emptyProps, props } from '@ngrx/store'
import { MarkerDimension } from '../case/case.state'
import { PlotAxis } from './plot-data.state'

export const plotDataActions = createActionGroup({
    source: 'Case',
    events: {
        'Load Data For Axis': props<{
            marker: MarkerDimension | null
            axis: PlotAxis
        }>(),
        'Load Data Both Axes': props<{
            markerXAxis: MarkerDimension
            markerYAxis: MarkerDimension
        }>(),
        'Sync Marker Axes': props<{
            markerX: MarkerDimension
            markerY: MarkerDimension
        }>(),
        'Reload Plot For Loaded Maps': emptyProps(),
        'Begin Loading Plot Data': emptyProps(),
        'Load Multi Mapping Plot Data': props<{
            markerXName: string
            markerYName: string
        }>(),
        'Plot Drawn': emptyProps(),
        'Clear Marker Axes': emptyProps(),
        'Set Point Size': props<{ size: number }>(),
        'Set Point Opacity': props<{ opacity: number }>(),
        'Set Lasso Type': props<{ lassoType: string }>(),
    },
})
